module.exports = __webpack_public_path__ + "static/media/SharpSans-Book.c7b7b0ad.woff";